module.exports = __webpack_public_path__ + "img/inu_gallery15.158eb61d.jpg";